import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

const state = {
// 判断安卓ios 是否获取token成功开关
  isCommonSwitchval: 0,
  atagsArr: [
    {
      ico: require("@/assets/imgs/lyyw.png"),
      title: "乐园游玩",
    },
    {
      ico: require("@/assets/imgs/mscy.png"),
      title: "美食餐饮",
    },
    {
      ico: require("@/assets/imgs/more.png"),
      title: "汤泉民宿",
    },
    {
      ico: require("@/assets/imgs/sgsx.png"),
      title: "水果生鲜",
    },
    {
      ico: require("@/assets/imgs/glhy.png"),
      title: "各类会员",
    },
    {
      ico: require("@/assets/imgs/xqb.png"),
      title: "兴趣班"
    },
    {
      ico: require("@/assets/imgs/qzhd.png"),
      title: "亲子活动"
    },
    {
      ico: require("@/assets/imgs/ycmy.png"),
      title: "孕产母婴"
    },
    {
      ico: require("@/assets/imgs/zjyj.png"),
      title: "早教幼教"
    },
    {
      ico: require("@/assets/imgs/shfw.png"),
      title: "生活服务",
    },
  ], //分类按钮
  orderObj:{
    reasonLists:JSON.parse(localStorage.getItem("reasonListsInfo")) || [], // 退款原因
    ticketsLists:JSON.parse(localStorage.getItem("ticketsListsInfo")) || [], // 可使用的电子票
  }
}

const mutations = {
    changeSwitch(state) {
      state.isCommonSwitchval = 1
    },
    goBack() {
      window.history.back()
    },
    getReasonList(state,param) {
      localStorage.setItem('reasonListsInfo',JSON.stringify(param.reasonLists))
      localStorage.setItem('ticketsListsInfo',JSON.stringify(param.ticketsLists))
      state.orderObj.reasonLists = param.reasonLists
      state.orderObj.ticketsLists = param.ticketsLists
    }
}

const getters = {

}

const actions = {
  getwyLists(context,args) {
    context.commit('getwyLists',args)
  }
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters
})



// WEBPACK FOOTER //
// ./src/store/index.js